import { useQuery } from '@apollo/client';

import { CAN_SOFT_DELETE_CHAT_THREADS } from '../../../queries/chats';
import { useChatOverlayContext } from '../contexts/chat-overlay-context';

export function useCanDeleteArchivedChats(): boolean {
  const { isPublicMode } = useChatOverlayContext();
  const { data } = useQuery(CAN_SOFT_DELETE_CHAT_THREADS, {
    skip: isPublicMode,
    fetchPolicy: 'cache-first',
  });

  return data?.canSoftDeleteChatThreads ?? false;
}
